import { FeeLevel, GasFeeInfo, CoinInfo, CommonWalletInfo } from './common';
import { PoolInfo } from './pool';

export type GetRewardQueryV2Params = {
  poolId: number;
  poolCode: string;
  poolType: string;
  chainCode: string;
};

export type GetRewardQueryV3Params = {
  poolId: number;
  walletAddress: string;
  chainId: number;
};

export enum RewardType {
  None = 1,
  Queue = 2,
  Normal = 3,
}

export enum Process {
  None,
  Disclaime,
  GasFeeTip,
  Confirm,
  Result,
}

// 查询奖励
export type RewardQuery = {
  amount: string;
  coin: string;
  contractAddress: string;
  usdPrice: string;
  iconUrl: string;
  symbol: string;
  /**
   * 1: 没有可领取的资金
   * 2: 排队中
   * 3: 正常可领取
   */
  rewardStatus: RewardType;
  coinDetailJson: CoinInfo;
  funds?: string;
};

export type GetRewardQueryV2Res = RewardQuery[];

export type GetRewardQueryV3Res = RewardQuery[];

export type PostClaimEncodeParams = CommonWalletInfo & {
  poolId: number;
  slippage?: string;
  requestInfos?: string[];
};

export enum ClaimEncodeStage {
  ApproveAmount = 31,
  ApproveTrade = 39,
  UnKnow = 0,
}

export type PostClaimEncodeRes = {
  orderCode: string;
  stage: ClaimEncodeStage;
  txDataList: Array<{
    data: `0x${string}`;
    from: string;
    gasLimit: string;
    to: `0x${string}`;
    value: string;
    gasFee: string;
    gasPrice: string;
  }>;
};

export type PostSaveClaimOrderParam = PostClaimEncodeParams & {
  stage: ClaimEncodeStage;
  useThirdConfig?: boolean;
  walletType?: number;
  orderCode?: string;
  walletId?: string;
  // 是否广播 null，0-不广播 1-广播
  broadcast?: number;
  broadcastData?: {
    signData: string;
    chainId: number;
    from: string;
    to: string;
    value: string;
    txHash: string;
  }[];
};

export type PostSaveClaimOrderRes = {
  orderCode: string;
  orderTxId: number;
};

export type GasStore = {
  level: FeeLevel;
  amount: string;
  price: string;
  estimateFee: string;
  priority: string;
  max: string;
  symbol: string;
  limit: string;
  gasPrice: string;
  isLoading: boolean;
  hasGasFee: boolean;
  loopPercent: number;
};

export type ClaimOption = {
  slippage: string;
  supportWallets: number[];
  balance: string;
  rewardType: RewardType;
  rewardValue: number;
  claimStage: ClaimEncodeStage;
  process: Process;
  gasStore: GasStore;
  claimType: ClaimType;
  poolInfo: PoolInfo;
  hasReward?: boolean;
  rewardFunds?: string[];
  startLoopGasFee: () => void;
  onChangeButtonLoading: (v: boolean) => void;
  onChangeProcess: (v: Process) => void;
  onChangeClaimStage: (v: ClaimEncodeStage) => void;
  onClose: () => void;
  onSuccess: () => void;
};

export type GetClaimFeeParams = {
  poolId: number;
  poolCode: string;
  poolType: string;
  level: FeeLevel;
  slippage: string;
};

export type GetClaimFeeRes = {
  gas: GasFeeInfo;
};

export type PostRewardClaimParams = {
  poolId: number;
  poolCode: string;
  poolType: string;
  gasLimit: number;
  priority: number;
  baseFee: number;
  gasMax: number;
  maxPriorityFeePerGas: number;
};

export enum ClaimType {
  // 领取奖励
  Claim,
  // 赎回本金
  RedeemPrincipal,
}
